export default __webpack_public_path__ + "static/cruiselines-royal-activities-8-83f03d3d3fdb9a9689cf45900806669f.jpg";